import { BlogsPostProps } from 'components/molecules/BlogPost/types';

const blogs: BlogsPostProps[] = [
  // {
  //   title: '',
  //   date: ,
  //   url: ',
  // },
  // {
  //   title: '',
  //   date: new Date('2020-11-14'),
  //   url: ',
  // },
  // {
  //   title: '',
  //   date: ,
  //   url:
  //     '',
  // },
  // {
  //   title: '',
  //   date: ,
  //   url: '',
  // },
];

export default blogs;
